import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { OccurrencePriorities } from '../../schemas/dispatch';

interface Props {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<OccurrencePriorities>>;
    zIndex?: number;
    required?: boolean;
}

export default function PriorityDropdown({ value, setValue, zIndex, required }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);

    async function getPriorities() {
        try {
            const response = await dispatchService.getOccurrencePriorities();
            setItems(response.map(priority => ({
                label: translate(priority), value: priority
            })));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getPriorities();
    }, []);

    return (
        <FilterDropdown
            label={translate('priority')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelFontSize={14}
            required={required}
        />
    );
}
